export default "__VITE_ASSET__CtI4h3mc__"